// AGOL-gruppen brukeren må være medlem av for å få tilgang til kommunens
// Drømmeplan-data.
export const DROMMEPLAN_AGOL_GROUP = 'Drømmeplan';
